import React from "react";
import "../css/loading.css";
const Loader = ({ smaller }) => {
  return (
    <div className="afLoader">
      <div className={smaller ? "dots smaller" : "dots"}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default Loader;
